React = require 'react'
t = require('views/internal/recup-with-helpers')('org_account')
track = require 'debug/track'
l = require 'lib/localize'

module.exports = class extends React.Component
  displayName: 'BoardCreateVisibilityRestrictionsComponent'

  render: t.renderable ->
    { isAdmin, hasBC, restrictions } = @props

    t.div '.setting-item-detail', ->
      t.div '.markeddown', ->
        for visibility in ['public', 'org', 'private']
          t.p ->
            t.format ['org board create visibility', visibility, restrictions[visibility]]

      if hasBC && !isAdmin
        t.p '.helper.u-float-left', ->
          t.format 'you-need-to-be-an-admin-to-change-this-setting'



// WEBPACK FOOTER //
// ./app/scripts/views/organization/board-create-visibility-restrictions-component.coffee